import PageLayout from "@/components/PageLayout";
import ArticleSchema from "@/components/ArticleSchema";

const VeiligheidsvestenHesjes = () => (
 <PageLayout
 title="Veiligheidsvesten en veiligheidshesjes"
 metaDescription="Veiligheidsvesten en veiligheidshesjes bedrukken met bedrijfslogo. Fluorescerende kleuren, reflecterende strepen. Magic Print Den Haag."
 >
 <ArticleSchema title="Veiligheidsvesten en veiligheidshesjes" description="Veiligheidsvesten en hesjes bedrukken met bedrijfslogo." slug="/veiligheidsvesten-en-veiligheidshesjes" />
 <h1 className="text-3xl md:text-5xl font-bold mb-6">
 Veiligheidsvesten en veiligheidshesjes
 </h1>
 <p className="text-lg text-muted-foreground mb-8">
 Veiligheidsvesten en veiligheidshesjes zijn onmisbaar voor bedrijven waar zichtbaarheid en veiligheid prioriteit hebben. Bij Magic Print kunt u deze laten bedrukken met uw bedrijfslogo voor een professionele uitstraling.
 </p>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Waarom veiligheidsvesten bedrukken?</h2>
 <ul className="space-y-2 text-muted-foreground">
 <li> Vergroot de zichtbaarheid van uw medewerkers</li>
 <li> Fluorescerende kleuren en reflecterende strepen</li>
 <li> Professionele uitstraling met uw bedrijfslogo</li>
 <li> Goedgekeurde merken: Portwest, Yoko, B&C Pro</li>
 <li> Geschikt voor bouw, wegenbouw, evenementen en meer</li>
 </ul>
 </section>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Bedrukking en borduring</h2>
 <p className="text-muted-foreground">
 Alle veiligheidsvesten en hesjes kunnen wij bedrukken of borduren met uw bedrijfslogo. Zo combineert u veiligheid met een professionele uitstraling. Neem contact met ons op voor een offerte op maat.
 </p>
 </section>
 </PageLayout>
);

export default VeiligheidsvestenHesjes;
